import { useEffect, useRef, useState } from "react";

// Hook simple pour révéler un élément quand il entre dans le viewport
export default function useRevealOnScroll(threshold = 0.15) {
  const ref = useRef(null);
  const [revealed, setRevealed] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setRevealed(true);
            observer.unobserve(node);
          }
        });
      },
      { threshold }
    );

    observer.observe(node);

    return () => {
      try {
        observer.unobserve(node);
      } catch (e) {}
    };
  }, [threshold]);

  return { ref, revealed };
}
